// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"styles_modalWrapper__p3xAj","lightBlub":"styles_lightBlub__XpKTq","credibleTip":"styles_credibleTip__JVhul","tipHeader":"styles_tipHeader__j4Sfl"};